import { render, staticRenderFns } from "./AvatarUploader.vue?vue&type=template&id=2d157bf2&lang=pug&"
import script from "./AvatarUploader.vue?vue&type=script&lang=ts&"
export * from "./AvatarUploader.vue?vue&type=script&lang=ts&"
import style0 from "./AvatarUploader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports